const SET_ACCOUNT = 'SET_ACCOUNT';
const SET_APP_LOADING = 'SET_APP_LOADING';
const SET_SELECTED_PLANT = 'SET_SELECTED_PLANT';
const SET_SIDEBAR_EXPANDED = 'SET_SIDEBAR_EXPANDED';
const SET_SELECTED_PLANT_ID = 'SET_SELECTED_PLANT_ID';
const SET_CONTEXTUAL_MENU_ITEMS = 'SET_CONTEXTUAL_MENU_ITEMS';

// TODO: remove this comment if we keep this refactor
const SET_SELECTED_ENTRANCE_PLANT = 'SET_SELECTED_ENTRANCE_PLANT';
const SET_SELECTED_ENTRANCE_PLANT_ID = 'SET_SELECTED_ENTRANCE_PLANT_ID';

export {
  SET_ACCOUNT,
  SET_APP_LOADING,
  SET_SELECTED_PLANT,
  SET_SIDEBAR_EXPANDED,
  SET_SELECTED_PLANT_ID,
  SET_CONTEXTUAL_MENU_ITEMS,
  SET_SELECTED_ENTRANCE_PLANT, // TODO: remove this comment if we keep this refactor
  SET_SELECTED_ENTRANCE_PLANT_ID, // TODO: remove this comment if we keep this refactor
};
